import * as yaml from 'js-yaml';
import GalleryDialog from './GalleryDialog';
import ImageSlider from './ImageSlider';
import React, { useState, useRef } from 'react';
import clsx from 'clsx';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import { ReactComponent as IconLeft } from '../assets/svg/left-arrow.svg';
import { ReactComponent as IconRight } from '../assets/svg/right-arrow.svg';
import { Orientation, Direction, BlockType } from '../common/enums';
import { getText, getPath } from '../common/utils/helpers';
import { useSelector, useDispatch } from 'react-redux';
import { StyleRules, createStyles, makeStyles } from '@mui/styles';

interface IProps {
  data: any;
  thumbSize?: BlockType;
}

const useStyles = makeStyles(
  (): StyleRules =>
    createStyles({
      imageContainerStyle: {
        width: '100%',
        // margin: '0 0 10px 30px',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
      },
      imgStyle: {
        // width: '570px',
        // height: '370px',
        maxWidth: '570px',
        maxHeight: '370px',
        objectFit: 'cover',
        border: `1px solid ${COLORS.circleGray}`,
        cursor: 'pointer',
      },
      verticalImgStyle: {
        objectFit: 'contain',
      },
      noOpenstyle: {
        cursor: 'default',
      },
      thumbContainerStyle: {
        maxWidth: '570px',
        position: 'relative',
        // marginTop: '10px',
        width: '100%',
        height: '140px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      thumbContainerSmallStyle: {
        height: '50px',
      },
      iconWrapperStyle: {
        position: 'absolute',
        width: '20px',
        height: '40px',
        borderRadius: '50%',
        // marginTop: '30px',
        // border: `1px solid ${COLORS.backgroundGray}`,
        // background: COLORS.backgroundGray,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        '@media (hover: hover) and (pointer: fine)': {
          '&:hover': {
            opacity: '0.7',
            transition: '0.5s ease',
          },
        },
      },
      iconStyle: {
        width: '20px',
      },
      leftStyle: {
        left: 0,
      },
      rightStyle: {
        right: 0,
      },
    })
);

const ImageContainer = ({ data, thumbSize }: IProps): JSX.Element => {
  const classes = useStyles();
  const lng = useSelector((state: any) => state.app.lng);
  const childRef = useRef<any>();

  const [galleryPhotoNr, setGalleryPhoto] = useState(1);
  const [isGalleryVisible, setGalleryVisible] = useState(false);

  const { content, images } = data;

  const urlPrefix = getPath();
  const currentImageData = images[galleryPhotoNr - 1];
  const currentImg: string = `${urlPrefix}${currentImageData?.url}`;

  const isPortrait =
    currentImageData?.dimensions?.orientation === Orientation.PORTRAIT;

  const isSliderVisible: boolean = images?.length > 1;
  const isCoverOnly: boolean = images?.length === 1 && images[0].cover;

  const openGallery = (photoNumber = 1) => {
    setGalleryVisible(true);
    setGalleryPhoto(photoNumber);
  };

  const closeGallery = () => {
    // setGalleryPhoto(null);
    setGalleryVisible(false);
  };

  const items: any[] = [];

  const getImageItem = (image) => {
    const { content: imageContent } = image;
    const description: string =
      (imageContent && getText(imageContent, 'text', lng)) || '';
    const original: string = `${urlPrefix}${image.url}`;
    const thumbnail: string = `${urlPrefix}${image.thumb}`;

    const item = {
      original,
      thumbnail,
      description,
    };

    return item;
  };

  // if (isSliderVisible) {
  for (const image of images) {
    if (image?.cover) {
      continue;
    }

    const item = getImageItem(image);

    items.push(item);
  }
  // }

  // if (!isSliderVisible && isCoverOnly) {
  //   const item = getImageItem(images[0]);
  //   items.push(item);
  // }

  const isArrowsVisible: boolean = items?.length > 4;

  const getGallery = () => {
    return (
      <GalleryDialog
        content={content}
        data={items}
        onClose={closeGallery}
        startImage={galleryPhotoNr}
      />
    );
  };

  const onArrowClick = (event?: any) => {
    event?.stopPropagation?.();
    event?.preventDefault?.();

    const direction = event?.currentTarget?.getAttribute('data-name');

    if (childRef) {
      childRef.current?.goTo(direction);
    }
  };

  const onImageClick = (event?: React.SyntheticEvent) => {
    event?.stopPropagation?.();
    event?.preventDefault?.();

    if (isCoverOnly) {
      return;
    }

    // const screenWidth = window.innerWidth;

    // if (screenWidth > 1170) {

    openGallery(galleryPhotoNr);
    // }
  };

  return (
    <>
      <div className={classes.imageContainerStyle}>
        <img
          onClick={onImageClick}
          src={currentImg}
          alt=""
          className={clsx(
            classes.imgStyle,
            isPortrait && classes.verticalImgStyle,
            isCoverOnly && classes.noOpenstyle
          )}
        />
        {isSliderVisible && (
          <div
            className={clsx(
              classes.thumbContainerStyle,
              thumbSize === BlockType.SMALL && classes.thumbContainerSmallStyle
            )}
          >
            {isArrowsVisible && (
              <>
                <div
                  className={clsx(classes.iconWrapperStyle, classes.leftStyle)}
                >
                  <IconLeft
                    className={classes.iconStyle}
                    data-name={Direction.LEFT}
                    onClick={onArrowClick}
                  />
                </div>
                <div
                  className={clsx(classes.iconWrapperStyle, classes.rightStyle)}
                >
                  <IconRight
                    className={classes.iconStyle}
                    data-name={Direction.RIGHT}
                    onClick={onArrowClick}
                  />
                </div>
              </>
            )}
            <ImageSlider
              data={items}
              openImage={openGallery}
              ref={childRef}
              thumbSize={thumbSize}
            />
          </div>
        )}
      </div>
      {isGalleryVisible && getGallery()}
    </>
  );
};

export default ImageContainer;
